import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable()
export class ImagesService {
  public static buildUrl(path: string, options: IImagesOptions = {}): string {
    let url = environment.imagesPath;

    const optionsParams = Object.getOwnPropertyNames(options).reduce(
      (prev, curr) => `${prev}${curr}=${options[curr]},`,
      ''
    );
    const format = path?.slice(-4) === '.gif' ? 'webp' : 'auto';
    url += `${optionsParams}q=80,f=${format},${path}`;

    return url;
  }

  public static improveSEOProductPathImg(imgPath: string, productPath: string) {
    if (!imgPath) {
      return '/notFound/placeholder.jpg';
    }
    // We had the name of the band and the name of the product to the path of the image
    // The NetApp has a rule to redirect /produit/xxx-yyy-zzz-0123456-1.jpg to /produit/0123456-1.jpg
    let finalSEOParam = '';
    if (productPath) {
      const pathProduct = productPath.split('/');
      const SEOAdding = pathProduct.pop();
      finalSEOParam = SEOAdding.replace(/[0-9]*\.shtml/, '');
    }

    const pathImg = imgPath.split('/produit/');
    return '/produit/' + finalSEOParam + (pathImg[1] ? pathImg[1] : pathImg);
  }
}

export interface IImagesOptions {
  w?: number | string;
  h?: number | string;
  fit?: 'scale-down' | 'contain' | 'cover' | 'crop' | 'pad';
}
